/**
 * @name BackupService
 * @description Servicio para la gestión de backups
 * @author Gerado de León
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = `${Environment.getCurrent().endpoints.orgChart}/Administracion/Backup`;

/**
 * Consulta los backup de un usuario
 * @return {any} promise
 */
const get = () => {
  let URL = `${BASE_URL}`;

  return axios.get(URL).then(({ data }) => {
    console.log('GET data', data);
    return data;
  });
};

/**
 * Consulta los backup asignados de un usuario
 * @return {any} promise
 */
const getAssigments = () => {
  let URL = `${BASE_URL}Asignado`;

  return axios.get(URL).then(({ data }) => {
    console.log('GETASSIGMENTS data', data);
    return data;
  });
};

/**
 * Registra un backup
 * @param {any} request { IdEmpleaoBackup, Fecha Inicio, Fecha Fin, Comentario }
 * @return {any} promise
 */
const post = (request) => {
  let URL = `${BASE_URL}`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Cancelar o rechazar un backup
 * @param {any} request { IdBackup, Comentario, Estatus }
 * @return {any} promise
 */
const put = (request) => {
  let URL = `${BASE_URL}RechazarCancelar`;

  return axios.put(URL, request).then(({ data }) => {
    return data;
  });
};

export const BackupService = {
  get,
  getAssigments,
  post,
  put,
};